function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 15.543A7.543 7.543 0 118 .457a7.543 7.543 0 010 15.086zM8 9.37c.757 0 1.371-.614 1.371-1.371V3.2a.686.686 0 00-.685-.686.79.79 0 00-.783.68l-.455 3.181a1.371 1.371 0 01-1.06 1.145l-1.49.331a.855.855 0 00-.67.835c0 .378.308.685.686.685H8z",
  fill: "#636B75"
});

var SvgTime = function SvgTime(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8 15.5429C3.8342 15.5429 0.457146 12.1658 0.457146 8C0.457146 3.8342 3.8342 0.457144 8 0.457144C12.1658 0.457144 15.5429 3.8342 15.5429 8C15.5429 12.1658 12.1658 15.5429 8 15.5429ZM8 9.37143C8.75742 9.37143 9.37143 8.75742 9.37143 8V3.2C9.37143 2.82129 9.06443 2.51429 8.68572 2.51429C8.29226 2.51429 7.95867 2.8036 7.90303 3.19311L7.44844 6.37524C7.36772 6.94028 6.94548 7.39625 6.3883 7.52006L4.89796 7.85125C4.50685 7.93816 4.22857 8.28506 4.22857 8.68572C4.22857 9.06442 4.53558 9.37143 4.91429 9.37143H8Z' fill='%23636B75'/%3E %3C/svg%3E";
export { SvgTime as ReactComponent };